export const defaultGetShouldRetryBasedOnResponse = ({
  response: { status },
}: {
  response: Response;
}): boolean => status === 429 || status === 503;
